var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1013.8 931.9",
    style: {
      enableBackground: "new 0 0 1013.8 931.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.75,
    y1: -33.35,
    x2: 891,
    y2: 734.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#838383"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M911.8,351.7l-8-26.6l-131.9,0.3l172-0.4l32.6-68.3l-33.6,1.3l-18.1-9.4l89-105.3l-109.1,19.2l61.6-120.6 L839.9,68l40.9-8.5l-58.9-17.6l-48.7,10.2L848.1,0L735.6,11.6l-72.2,44.5l37.5-54.2L600.3,26.7l-22.1,29.4l-71.3,32l-71.4-32 l-22.1-29.4L312.9,1.9l37.5,54.2l-72.2-44.5L165.7,0l74.9,52.1l-48.7-10.2L133,59.5l40.8,8.5L47.5,41.9L109,162.4L0,143.3 l88.9,105.3l-18,9.4l-33.7-1.3L69.9,325l172,0.4L110,325.1l-8.1,26.6L84,355.1l-60.1,12.7l78,22.8V516l43.6-29.7l-2,33.9l-7.3,228.2 l74.3-124.8l8,167.3l25.9-58.2l51.2,131.2l12.4-67.4l-2.3-5.6l30.6,73l25.9-20l36.6,70l3.7-60L389,837.2l76.9,94.7l-17.4-94.7 l20.5-18.6l-27.8-53.2l-16.9-10.2l82.6,49.7l-65.7-39.5L506.9,891l65.6-125.5l0,0l-27.7,53.1l20.4,18.6l-17.3,94.7l76.8-94.7 l-13.5,16.7l3.8,60l36.6-70l25.9,20l28.2-67.3l12.4,67.3l51.3-131.1l25.9,58.1l7.9-167.3l74.3,124.8l-7.3-228.2l-2-33.9l43.6,29.7 V390.7l78.1-22.9l-60.1-12.7L911.8,351.7z M845.8,172.8l31.7,71.5l-55.6-125.4L845.8,172.8z M136.2,244.3l31.7-71.5l24-53.9 L136.2,244.3z M334.1,576.1l-6-15.2l8.8,22.2L334.1,576.1z M679.7,576.1l-2.8,7l8.8-22.2L679.7,576.1z M506.9,150.9l-178.8,47.8 l87.8-23.5L506.9,150.9l90.9,24.3l87.9,23.5L506.9,150.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBw);
export default __webpack_public_path__ + "static/media/logo_bw.8b0130ed7dfb55168b8fa81c4fce148d.svg";
export { ForwardRef as ReactComponent };